import {TemplateResult, html, css} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {msg, localized} from '@lit/localize';
import BaseElement from 'gmfapi/elements/BaseElement';
import {Subscription} from 'rxjs';

import {IProduct, IOrder} from '../../services/geoshop_api';
import geoshopOrder, {NoExtentError, CartEmptyError} from '../../services/geoshop_order';

@localized()
@customElement('geoshop-cart')
export class GeoShoppingCart extends BaseElement {
  @state() products: IProduct[] = [];
  @state() hasExtent: boolean = false;
  private subscriptions: Subscription[] = [];

  connectedCallback(): void {
    super.connectedCallback();
    this.subscriptions.push(geoshopOrder.orderProducts.subscribe((products) => (this.products = products)));
    this.subscriptions.push(geoshopOrder.extent.subscribe((extent) => (this.hasExtent = extent !== null)));
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async makeOrder() {
    const privateElement = this.shadowRoot.getElementById('private-order');
    try {
      await geoshopOrder.makeOrder(privateElement.checked);
    } catch (err) {
      if (err instanceof NoExtentError) {
        alert('Extent is empty');
      }
      if (err instanceof CartEmptyError) {
        alert('Cart is empty');
      }
    }
  }

  static styles = css`
    button {
      color: white;
    }
  `;
  //
  //     button[part='add'] {
  //       width: 2.3rem !important;
  //       height: 2.3rem !important;
  //       padding: 0 !important;
  //       padding-top: 0.3rem !important;
  //       margin: 0 auto;
  //     }
  //     `;
  //

  createOrderedItem(product: IProduct) {
    return html` <li class="cart-item">
      <span> ${product.label} </span>
      <span class="placeholder"> </span>
      <button
        @click=${() => {
          geoshopOrder.removeProduct(product.id);
        }}
        class="close-button"
        data-toggle="tooltip"
        data-placement="left"
        data-original-title="${msg('Order in GeoShop')}"
      >
        ✕
      </button>
    </li>`;
  }

  privateSelector(): TemplateResult {
    return html`
      <div>
        <label>
          <input type="radio" id="private-order" name="order_type" value="private" checked />
          Private
        </label>
        <label>
          <input type="radio" id="public-order" name="order_type" value="public" />
          Public
        </label>
      </div>
    `;
  }

  render(): TemplateResult {
    return html`
      <div id="geoshop-cart" class="geoshop-block">
        <div>Shopping Cart:</div>
        <ul>
          ${this.products.map((p: IProduct) => this.createOrderedItem(p))}
        </ul>
        ${this.privateSelector()}
        <button
          class="plain-button"
          ?disabled=${!this.hasExtent || this.products.length === 0}
          @click=${() => this.makeOrder()}
        >
          <span>
            <span>Order</span>
            <span class="placeholder"> </span>
            <span id="cart-order"> </span>
          </span>
        </button>
      </div>
    `;
  }
}
